// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-video-video-inner-xyivo{padding-top:56.25%;position:relative;width:100%}.components-video-video-wrapper-btfsg{align-items:center;display:flex;justify-content:center;width:100%}.components-video-video-frame-jwkwx{height:100%;width:100%;bottom:0;left:0;position:absolute;right:0;top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inner": "components-video-video-inner-xyivo",
	"wrapper": "components-video-video-wrapper-btfsg",
	"frame": "components-video-video-frame-jwkwx"
};
module.exports = ___CSS_LOADER_EXPORT___;
